var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { transition: "dialog-top-transition", "max-width": "800" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      attrs: { elevation: "0" },
                      domProps: { textContent: _vm._s("Forgot Password?") }
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                )
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _vm._v(" "),
      _vm.dialog
        ? _c(
            "v-card",
            { staticClass: "white rounded-xl" },
            [
              _c("v-card-title", {
                staticClass: "headline justify-center font-weight-bold",
                domProps: { textContent: _vm._s("Reset Password") }
              }),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("v-text-field", {
                    attrs: { label: "email" },
                    model: {
                      value: _vm.email,
                      callback: function($$v) {
                        _vm.email = $$v
                      },
                      expression: "email"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "justify-center" },
                [
                  _c("v-btn", {
                    staticClass: "secondary",
                    domProps: { textContent: _vm._s("Reset") },
                    on: {
                      click: function($event) {
                        return _vm.handleReset(_vm.email)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }